<ul class="breadcrumb" >
  <li *ngFor="let item of listBreadcrumb; let last = last"
      (click)="onClick(item)"
      (keydown.enter)="onClick(item)"
      [class.breadcrumb-item]="!last"
      [class.breadcrumb-item-active]="last"
      (keypress.enter)="onClick(item)">
    <app-icon [name]="item?.icon" height="17px" width="17px"></app-icon>
    <span>{{ item?.label }}</span>
  </li>
</ul>
